<template>
  <v-container fluid class="font">
    <!--BEGIN exemption policy-->
    <v-dialog
      persistent
      v-model="exemptionPolicyDialog"
      max-width="50%"
      height="70vh"
      class="exemptions"
      :fullscreen="$vuetify.breakpoint.mobile"
    >
      <v-card>
        <v-card-text class="summary">
          <v-row class="image">
            <v-col cols="12" md="2" class="text-center">
              <v-img
                width="150"
                height="150"
                alt="disclaimer"
                class="text-center"
                src="../../../assets/images/warning.png"
              />
            </v-col>
            <v-col cols="12" md="10">
              <div class="ma-4">
                <p style="color: red" class="font-weight-bold">
                  DISCLAIMER! READ THE FOLLOWING EXEMPTION POLICY TO PROCEED!
                </p>
                <v-divider class="my-2" />
                <v-list class="exemptions">
                  <v-list-item>
                    <p>
                      <v-icon>mdi-menu-right</v-icon> Exemptions may, on
                      application, be granted to registered students who are
                      holders of qualifications/certifications recognized by
                      KISEB. Exemptions will be granted on a paper by paper
                      basis upon application.
                    </p>
                  </v-list-item>
                  <v-list-item>
                    <p>
                      <v-icon>mdi-menu-right</v-icon>
                      Application for exemption must be submitted within the
                      portal.
                    </p>
                  </v-list-item>
                  <v-list-item>
                    <p>
                      <v-icon>mdi-menu-right</v-icon>
                      Exemptions take into consideration the applicant’s
                      previous studies and examination results;
                    </p>
                  </v-list-item>
                  <v-list-item>
                    <p>
                      <v-icon>mdi-menu-right</v-icon>
                      Applicant must have obtained at least 50% (C) in the
                      previous examination in the subject submitted for
                      exemption;
                    </p>
                  </v-list-item>
                  <v-list-item>
                    <p>
                      <v-icon>mdi-menu-right</v-icon>
                      Exemptions may be considered where 70% or above of the
                      previously studied examination syllabus is identical in
                      mapping to the CPSP syllabus;
                    </p>
                  </v-list-item>
                  <v-list-item>
                    <p>
                      <v-icon>mdi-menu-right</v-icon>
                      No exemption will be given to applicants whose
                      qualifications are obtained by exemptions from local or
                      overseas educational institutes;
                    </p>
                  </v-list-item>
                  <v-list-item>
                    <p>
                      <v-icon>mdi-menu-right</v-icon>
                      Exemptions are applicable in non-core modules in PARTS I
                      and II of CPSP-K examinations only;
                    </p>
                  </v-list-item>
                  <v-list-item>
                    <p>
                      <v-icon>mdi-menu-right</v-icon>
                      No exemptions will be granted in the Associate in
                      Procurement (APS) level examination;
                    </p>
                  </v-list-item>
                  <v-list-item>
                    <strong>
                      <v-icon>mdi-menu-right</v-icon>
                      A non-refundable exemption fee will be charged on
                      application.
                    </strong>
                  </v-list-item>
                </v-list>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider />

        <v-card-actions class="exemptions">
          <v-row>
            <v-col cols="12" md="6" sm="12" class="col1">
              <v-btn
                text
                @click="$router.back()"
                class="mt-md-3 custom-class error mb-sm-3"
              >
                <v-icon left> mdi-arrow-left </v-icon>
                Exit
              </v-btn>
            </v-col>
            <v-col cols="12" md="6" sm="12" class="col2 d-flex justify-center">
              <v-checkbox @click="closePolicyDialog">
                <template v-slot:label>
                  <div>
                    I agree to KISEB
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <a
                          target="_blank"
                          href="https://kiseb.or.ke/exemption-policy/"
                          v-on="on"
                          class="text-decoration-none"
                        >
                          Exemption Policy
                        </a>
                      </template>
                    </v-tooltip>
                  </div>
                </template>
              </v-checkbox>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--END exemption policy-->
    <v-card flat>
      <v-card-title>
        <v-btn text small @click="$router.back()">
          <v-icon left> mdi-arrow-left </v-icon>
          Back
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-form ref="exemptionForm" v-model="isValid">
          <v-row>
            <v-col cols="12" md="3" sm="6">
              <v-text-field
                label="Profile Number"
                dense
                v-model="formData.profileID"
                readonly
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" sm="6">
              <v-text-field
                label="Registration Number"
                dense
                v-model="formData.studentNo"
                readonly
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" sm="6">
              <v-text-field
                label="Programme"
                v-model="formData.programme"
                dense
                readonly
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" sm="6">
              <v-text-field
                label="Stage"
                dense
                readonly
                outlined
                v-model="formData.stage"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-btn
                color="primary"
                class="text-capitalize"
                v-if="!isReadonly"
                @click="exemptionUnitsDialogBox = true"
              >
                <v-icon left> mdi-plus </v-icon>
                Select Units
              </v-btn>
            </v-col>
            <v-col cols="12" md="12" v-if="isReadonly">
              <v-alert color="primary" dense outlined>
                {{ formData.comment }}
              </v-alert>
            </v-col>
            <v-col cols="12">
              <div class="attachment--documents">
                <v-chip-group
                  active-class="orange darken-2"
                  column
                  multiple
                  class="mx-2"
                >
                  <v-chip
                    v-for="(item, i) in attachments"
                    :key="i"
                    color="primary"
                    outlined
                    label
                    :disabled="isReadonly"
                  >
                    <v-btn
                      left
                      color="primary"
                      class="text-capitalize"
                      text
                      @click="editAttachment(item, i)"
                      :disabled="isReadonly"
                    >
                      {{ item.fileName }}
                    </v-btn>
                    <v-divider vertical></v-divider>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn
                          class="py-2 ml-4"
                          icon
                          :disabled="isReadonly"
                          right
                          v-on="on"
                          v-bind="attrs"
                          color="deep-orange"
                          @click="removeAttachment(i, item)"
                        >
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Remove Attachment</span>
                    </v-tooltip>
                  </v-chip>
                </v-chip-group>
                <div
                  class="d-flex justify-center flex-column"
                  v-if="
                    formData.examExemptionLines &&
                    formData.examExemptionLines.length > 0
                  "
                >
                  <div
                    :class="
                      attachments.length !== 0
                        ? 'align-self-center mt-3'
                        : 'align-self-center'
                    "
                  >
                    <ExemptionAttachments
                      :isEdit="isEdit"
                      :BtnCaption="BtnCaption"
                      @addAttachment="addAttachment"
                      :isReadonly="isReadonly"
                      :data="displayAttachment"
                    />
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-form>
        <v-divider />
        <v-row class="mt-2">
          <!--BEGIN action to attach units-->
          <div class="ma-4">
            <!--BEGIN exemptible units dialog-->
            <ExemptionUnits
              :exemptionUnitsDialogBox="exemptionUnitsDialogBox"
              @setExemptionUnitsModal="setExemptionUnitsModal"
              :formData="formData"
            />
            <!--END exemptible units dialog-->
          </div>
          <!--END action to attach units-->
          <!--BEGIN List of selected Units-->
          <v-card-text>
            <p>Selected Exemption Units</p>
            <v-data-table
              :headers="headers"
              :items="formData.examExemptionLines"
              item-key="id"
              class="itemRow"
              :sort-by="['dueDate']"
              :sort-desc="[false]"
              :items-per-page="5"
            >
              <template v-slot:[`item.code`]="{ item }">
                {{ item.lineNo ? item.unit : item.code }}
              </template>
              <template v-slot:[`item.programmeCode`]="{ item }">
                {{ item.lineNo ? item.programme : item.programmeCode }}
              </template>
              <template v-slot:[`item.stageCode`]="{ item }">
                {{ item.lineNo ? item.stage : item.stageCode }}
              </template>
              <template v-slot:[`item.educationLineNo`]="{ item }">
                {{ item.educationLineNo ? educationLevelsName(item) : "" }}
              </template>
              <template v-slot:[`item.comparableUnit`]="{ item }">
                {{ item.comparableUnit ? comparableUnitName(item) : "" }}
              </template>
              <template v-slot:[`item.accreditedInstituteCode`]="{ item }">
                {{ item.accreditedInstituteName }}
              </template>
              <!--BEGIN board actions-->
              <template v-slot:[`item.action`]="{ item, index }">
                <div class="d-md-flex justify-md-center">
                  <v-btn
                    outlined
                    small
                    color="primary"
                    v-if="!isReadonly"
                    class="mr-md-3"
                    @click="openDialog(item.code)"
                  >
                    <v-icon
                      v-if="
                        item.accreditedInstituteCode || item.awardingBodyCode
                      "
                      small
                      class="mr-1 ml-n1"
                    >
                      mdi-pencil
                    </v-icon>
                    <v-icon v-else>mdi-plus</v-icon>
                    <span class="table-exam">
                      {{
                        item.accreditedInstituteCode || item.awardingBodyCode
                          ? "Edit"
                          : "Add"
                      }}
                      institution</span
                    >
                  </v-btn>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        small
                        color="deep-orange lighten-1"
                        v-if="!isReadonly"
                        @click="removeLine(item, index)"
                      >
                        <!-- <span class="table-exam"> Remove Unit</span> -->
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Remove Unit</span>
                  </v-tooltip>
                </div>
              </template>
              <!--END board actions-->
            </v-data-table>
            <InstitutionDialog
              :InstitutionDialogBox="InstitutionDialogBox"
              @setInstitutionModal="setInstitutionModal"
              :formData="formData"
              :currentUnit="currentUnit"
            />
          </v-card-text>
          <!--END List of selected Units-->
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          elevation="0"
          v-if="!isEdit && !isReadonly"
          :disabled="formData.examExemptionLines.length === 0"
          color="primary"
          class="text-capitalize mb-5"
          @click="saveExemptedUnits"
        >
          <v-icon left> mdi-send </v-icon>
          <span>Save and Proceed To Payments</span>
        </v-btn>
        <v-btn
          color="primary"
          v-if="exemption && exemption.defer"
          @click="reopen(formData)"
          class="text-capitalize mb-5"
          elevation="0"
        >
          <v-icon>mdi-autorenew</v-icon>
          Re-submit
        </v-btn>
        <v-btn
          v-if="isEdit && !isReadonly"
          class="text-capitalize mb-5"
          color="primary"
          @click="updateExemption"
        >
          <v-icon left> mdi-send </v-icon>
          <span
            >Save
            {{
              formData.postedReceiptNo === "" ? "" : "and Proceed To Payment"
            }}</span
          >
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import ExemptionUnits from "./ExemptibleUnits";
import { helper } from "../../dashboard/utils";
import { AuthService } from "@brainspore/celadon-base/modules/auth";
import ExemptionAttachments from "./ExemptionAttachments";
import InstitutionDialog from "./InstitutionDialog";
import exemptionMixin from "../exemptionMixin";
export default {
  name: "ExemptionCard",
  mixins: [exemptionMixin],
  components: { ExemptionUnits, ExemptionAttachments, InstitutionDialog },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      if (to.params.code) {
        v.$store.dispatch("Exemption/getExemption", to.params.code);
        window.document.title = "KISEB::View Exemptions";
      } else {
        window.document.title = "KISEB::Apply Exemptions";
      }
      v.$store.dispatch("Exemption/exemptibleUnits");
      v.$store.dispatch("Exemption/getExemptionGradesSetup");
      v.$store.dispatch("Exemption/getaccreditedInstitute");
      v.$store.dispatch("Exemption/getawardingBodies");
      v.$store.dispatch("Profile/getProfile");
    });
  },
  data: () => ({
    attachments: [],
    displayAttachment: {},
    isValid: false,
    submitting: false,
    exemptionUnitsDialogBox: false,
    InstitutionDialogBox: false,
    exemptionPolicyDialogBox: false,
    currentUnit: {},
    formData: {
      profileID: "",
      studentNo: "",
      programme: "",
      stage: "",
      attachmentAPI: [],
      examExemptionLines: [],
      comparableUnit: "",
      gradeScored: "",
      awardingBodies: "",
      accreditedInstitute: "",
      accreditedInstituteName: "",
      educationLineNo: "",
    },
  }),
  created() {
    if (!this.$route.params.code) {
      this.exemptionPolicyDialogBox = true;
    }
  },
  mounted() {
    Event.$on("goToPayment", (code) => {
      let hash = this.encryptedPaymentParam(code);
      this.$router.replace({
        name: "ExemptionPayments",
        params: { code: hash },
      });
    });
  },
  computed: {
    exemptionPolicyDialog: {
      get() {
        return this.exemptionPolicyDialogBox;
      },
      set(value) {
        this.setExemptionPolicyModal(value);
      },
    },
    BtnCaption() {
      return this.attachments.length === 0
        ? "Attach Exemption Documents"
        : "Add Exemption Document";
    },
    exemption() {
      return this.$store.getters["Exemption/exemptionGetter"]("exemption");
    },
    exemptibleUnits() {
      return this.$store.getters["Exemption/exemptionGetter"](
        "exemptibleUnits",
      );
    },
    headers() {
      return [
        {
          text: "code",
          align: "left",
          sortable: false,
          value: "code",
        },
        {
          text: "Education Level",
          value: "educationLineNo",
          align: "left",
          sortable: false,
        },
        {
          text: "Unit Description",
          align: "left",
          sortable: false,
          value: "description",
        },
        {
          text: "Scored Grade",
          align: "left",
          sortable: false,
          value: "gradeScored",
        },
        {
          text: "Comparable Unit",
          align: "left",
          sortable: false,
          value: "comparableUnit",
        },
        {
          text: "Accredited Institute",
          align: "left",
          sortable: false,
          value: "accreditedInstituteCode",
        },
        {
          text: "Awarding Body",
          align: "left",
          sortable: false,
          value: "awardingBodyCode",
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
          value: "action",
        },
      ];
    },
    isEdit() {
      return this.$route.params.code && this.formData.status === "Open";
    },
    isReadonly() {
      return this.exemption.status
        ? this.exemption.defer || this.exemption.status !== "Open"
        : false;
    },
    // this computed value returns the programme name and the stage
    student() {
      return AuthService.user.student;
    },
    profile() {
      return AuthService.user.profile;
    },
    aacademics() {
      return this.$store.getters["Profile/academicsGetters"]("academics");
    },
  },
  methods: {
    encryptedPaymentParam(item) {
      return helper.encrypt(item);
    },
    setAttachmentDialog(val) {
      this.$store.dispatch("Exemption/setAttachmentDialog", val);
    },
    closePolicyDialog() {
      this.exemptionPolicyDialogBox = false;
    },
    editAttachment(val, index) {
      val.index = index;
      this.displayAttachment = val;
      this.setAttachmentDialog(true);
    },
    removeAttachment(index, item) {
      if (item.lineNo) {
        // delete exemption line
        this.$confirm.show({
          title: `Delete Exemption Attachment ${item.lineNo}?`,
          text: "Are you sure you want to delete this exemption Attachment, this action is irreversible",
          onConfirm: () => {
            this.$store.dispatch("Exemption/deleteAttachment", { ...item });
          },
        });
      } else {
        this.attachments.splice(index, 1);
      }
    },
    async addAttachment(file) {
      this.displayAttachment = {};
      if (file.index !== undefined) {
        Object.assign(this.attachments[file.index], file);
        delete this.attachments[file.index].index;
      } else {
        delete file.index;
        this.attachments.push(file);
      }
    },
    // set exempted units dialog
    setExemptionUnitsModal: function (value) {
      this.exemptionUnitsDialogBox = value;
    },
    setInstitutionModal: function (value) {
      this.InstitutionDialogBox = value;
    },
    // set exemption policy dialog
    setExemptionPolicyModal: function (value) {
      this.exemptionPolicyDialogBox = value;
    },
    // save the exempted units
    saveExemptedUnits: function () {
      this.submitting = true;
      if (!this.isValid) {
        this.$refs.exemptionForm.validate();
        this.submitting = false;
      } else if (this.attachments.length === 0) {
        //check for attachments
        Event.$emit("ApiError", "Attach supporting documents to proceed!");
      } else if (
        this.formData.examExemptionLines.filter((el) => el.gradeScored)
          .length !== this.formData.examExemptionLines.length
      ) {
        //check for the grades
        Event.$emit("ApiError", "Grade is required for exempted units!");
      } else if (
        this.formData.examExemptionLines.filter(
          (el) =>
            el.accreditedInstituteCode !== (null || "" || undefined) ||
            el.awardingBodyCode,
        ).length !== this.formData.examExemptionLines.length
      ) {
        //check for institution and awarding body
        Event.$emit(
          "ApiError",
          "An Institution or Awarding Body is required for exempted units!",
        );
      } else if (
        this.formData.examExemptionLines.filter((el) => el.comparableUnit)
          .length !== this.formData.examExemptionLines.length
      ) {
        //check for comparable units
        Event.$emit(
          "ApiError",
          "A Comparable Unit is required for exempted units!",
        );
      } else if (
        this.formData.examExemptionLines.filter((el) => el.educationLineNo)
          .length !== this.formData.examExemptionLines.length
      ) {
        //check for education levels in the units
        Event.$emit(
          "ApiError",
          "Education Levels are a requirement for all exempted units!",
        );
      } else {
        const data = { ...this.formData };
        Array.prototype.push.apply(data.attachmentAPI, this.attachments);
        data.examExemptionLines = data.examExemptionLines.map((el) => {
          return {
            unit: el.code,
            gradeScored: el.gradeScored,
            accreditedInstituteCode: el.accreditedInstituteCode,
            accreditedInstituteName: el.accreditedInstituteName,
            awardingBodyCode: el.awardingBodyCode,
            comparableUnit: el.comparableUnit,
          };
        });
        this.$store.dispatch("Exemption/saveExemptedUnits", {
          ...data,
        });
      }
    },
    updateExemption: function () {
      this.submitting = true;
      if (!this.isValid) {
        this.$refs.exemptionForm.validate();
        this.submitting = false;
      } else if (this.attachments.length === 0) {
        Event.$emit("ApiError", "Attach supporting documents to proceed!");
      } else if (
        this.formData.examExemptionLines.filter((el) => el.gradeScored)
          .length !== this.formData.examExemptionLines.length
      ) {
        Event.$emit("ApiError", "Grade is required for exempted units!");
      } else if (
        this.formData.examExemptionLines.filter((el) => el.comparableUnit)
          .length !== this.formData.examExemptionLines.length
      ) {
        Event.$emit(
          "ApiError",
          "A Comparable Unit is required for exempted units!",
        );
      } else if (
        this.formData.examExemptionLines.filter(
          (el) =>
            el.accreditedInstituteCode !== (null || "" || undefined) ||
            el.awardingBodyCode,
        ).length !== this.formData.examExemptionLines.length
      ) {
        //check for institution and awarding body
        Event.$emit(
          "ApiError",
          "An Institution or Awarding Body is required for exempted units!",
        );
      } else if (
        this.formData.examExemptionLines.filter((el) => el.educationLineNo)
          .length !== this.formData.examExemptionLines.length
      ) {
        //check for education levels in the units
        Event.$emit(
          "ApiError",
          "Education Levels are a requirement for all exempted units!",
        );
      } else {
        const data = { ...this.formData };
        delete data.documentDate;
        delete data.amount;
        delete data.amountLCY;
        data.attachmentAPI = [];
        Array.prototype.push.apply(data.attachmentAPI, this.attachments);
        data.examExemptionLines = data.examExemptionLines.map((el) => {
          return {
            ...el,
            unit: el.code,
            accreditedInstituteCode: el.accreditedInstituteCode,
            accreditedInstituteName: el.accreditedInstituteName,
            awardingBodyCode: el.awardingBodyCode,
            comparableUnit: el.comparableUnit,
          };
        });
        this.$store.dispatch("Exemption/patchExemption", {
          ...data,
        });
      }
    },
    removeLine: function (item, index) {
      if (item.lineNo) {
        // delete exemption line
        this.$confirm.show({
          title: `Delete Exemption Unit ${item.lineNo}?`,
          text: "Are you sure you want to delete this exemption unit, this action is irreversible",
          onConfirm: () => {
            this.$store.dispatch("Exemption/deleteLine", { ...item });
          },
        });
      } else {
        this.formData.examExemptionLines.splice(index, 1);
      }
    },
    openDialog(code) {
      this.currentUnit = this.formData.examExemptionLines
        .filter((el) => {
          if (el.code === code) return el;
        })
        .shift();
      this.InstitutionDialogBox = true;
    },
    comparableUnitName(item) {
      const filteredByUnit = this.exemptibleUnits
        .filter((el) => {
          return el.code === item.code;
        })
        .shift();
      if (filteredByUnit.length !== 0) {
        const comparableUnit = filteredByUnit.comparableUnits
          .filter((el) => {
            return el.code === item.comparableUnit;
          })
          .shift(0);
        return comparableUnit.length !== 0 ? comparableUnit.description : [];
      } else {
        return [];
      }
    },
    educationLevelsName(item) {
      const filteredByUnit = this.exemptibleUnits
        .filter((el) => {
          return el.code === item.code;
        })
        .shift();
      if (filteredByUnit.length !== 0) {
        const comparableUnit = this.aacademics
          .filter((el) => {
            return el.lineNo === item.educationLineNo;
          })
          .shift(0);
        return comparableUnit.length !== 0
          ? comparableUnit.certificateAwarded
          : [];
      } else {
        return [];
      }
    },
    isEmpty(item) {
      if (item !== undefined) {
        return Object.keys(item).length === 0;
      } else {
        return false;
      }
    },
  },
  watch: {
    exemption: {
      handler: function (data) {
        const attachments = data.attachmentAPI;
        delete data.attachmentAPI;
        this.formData = { ...data };
        const base64Attachments = [];
        this.formData.examExemptionLines = this.formData.examExemptionLines.map(
          (el) => {
            const unit = this.exemptibleUnits
              .filter((item) => item.code === el.unit)
              .shift();
            return { ...unit, ...el };
          },
        );
        attachments.map(async (el) => {
          const blob = await helper.getFileBlob(
            process.env.VUE_APP_TEMP_URL + el.base64Attachment,
            el.documentNo,
          );
          const base64 = await helper.toBase64(blob);
          base64Attachments.push({
            base64Attachment: base64.split(",")[1],
            fileName: `${blob.name}${el.lineNo}.${blob.type.split("/")[1]}`,
            comment: el.comment,
            blob,
            lineNo: el.lineNo,
            documentNo: el.documentNo,
            documentType: el.documentType,
          });
        });
        this.attachments = base64Attachments;
      },
    },
    exemptibleUnits() {
      this.formData.programme = this.exemptibleUnits[0].programmeCode;
      this.formData.stage = this.exemptibleUnits[0].stageCode;
      this.formData.profileID = this.profile["profileID"];
      this.formData.studentNo = this.student["no"];
    },
  },
};
</script>

<style scoped>
.font {
  font-family: "PT Sans Caption", sans-serif;
}
.attachment--documents {
  border-radius: 4px;
  padding: 1% 0 1% 0;
  border: 3px dashed green;
  background: #388e3c17;
}
@media all and (max-width: 480px) {
  .custom-class {
    width: 100%;
    display: block;
    margin-top: 0px;
  }
  .col1 {
    order: 2;
  }
  .col2 {
    order: 1;
  }
}
</style>
